import React from "react";
import {PermissionGuard} from "../../components/PermissionGuard";
import {AuditLogFeature} from "../../features/auditLog";

const ALLOWED_PERMISSION = 'auditLog'

const AuditLogPage = ({
  userToken,
  userPermissions,
}) => (
  <PermissionGuard
    userToken={userToken}
    userPermissions={userPermissions}
    permissionKey={ALLOWED_PERMISSION}
  >
    <AuditLogFeature
      userToken={userToken}
    />
  </PermissionGuard>
)

export default AuditLogPage
